export const REPAIR_ROLES = {
  GARAGE: "garage",
  EXPERT: "expert",
  ADMIN: "admin"
}

export const REPAIR_ACTIONS = {
  UPLOAD_FILES: "uploadFiles",
  DELETE_FILES: "deleteFiles",
  UPLOAD_REPAIRED_FILES: "uploadRepairedVehicleFiles",
  DELETE_REPAIRED_FILES: "deleteRepairedVehicleFiles",
  UPLOAD_REGISTRATION: "uploadRegistrationDocument",
  DELETE_REGISTRATION: "deleteRegistrationDocument",
  UPLOAD_FINANCIAL_OFFER: "uploadFinancialOffer",
  DELETE_FINANCIAL_OFFER: "deleteFinancialOffer",
  UPLOAD_ASSIGNMENT_REQUEST: "uploadAssignmentRequest",
  DELETE_ASSIGNMENT_REQUEST: "deleteAssignmentRequest",
  UPLOAD_OTHER_DOCUMENTS: "uploadOtherDocuments",
  DELETE_OTHER_DOCUMENTS: "deleteOtherDocuments",
  UPLOAD_INVOICE: "uploadInvoice",
  DELETE_INVOICE: "deleteInvoice",
  EDIT_VEHICLE: "editVehicleDetails",
  EDIT_INSURED: "editInsuredDetails",
  EXPERT_CALL: "expertCall",
  OPEN_REPAIR: "openRepair",
  CANCEL_EXPERT_DECISION: "cancelExpertDecision"
}

const { GARAGE, EXPERT, ADMIN } = REPAIR_ROLES
const {
  UPLOAD_FILES,
  DELETE_FILES,
  UPLOAD_REPAIRED_FILES,
  DELETE_REPAIRED_FILES,
  UPLOAD_REGISTRATION,
  DELETE_REGISTRATION,
  UPLOAD_FINANCIAL_OFFER,
  DELETE_FINANCIAL_OFFER,
  UPLOAD_ASSIGNMENT_REQUEST,
  DELETE_ASSIGNMENT_REQUEST,
  UPLOAD_OTHER_DOCUMENTS,
  DELETE_OTHER_DOCUMENTS,
  UPLOAD_INVOICE,
  DELETE_INVOICE,
  EDIT_VEHICLE,
  EDIT_INSURED,
  EXPERT_CALL,
  OPEN_REPAIR,
  CANCEL_EXPERT_DECISION
} = REPAIR_ACTIONS

export const REPAIR_PERMISSIONS = {
  10: {
    [GARAGE]: {
      [UPLOAD_FILES]: true,
      [DELETE_FILES]: true,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: true,
      [DELETE_REGISTRATION]: true,
      [UPLOAD_FINANCIAL_OFFER]: true,
      [DELETE_FINANCIAL_OFFER]: true,
      [UPLOAD_ASSIGNMENT_REQUEST]: true,
      [DELETE_ASSIGNMENT_REQUEST]: true,
      [UPLOAD_OTHER_DOCUMENTS]: true,
      [DELETE_OTHER_DOCUMENTS]: true,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: true,
      [EDIT_INSURED]: true,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false
    },
    [EXPERT]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: false
    },
    [ADMIN]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: false
    }
  },
  20: {
    [GARAGE]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: true,
      [DELETE_REGISTRATION]: true,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: true,
      [DELETE_ASSIGNMENT_REQUEST]: true,
      [UPLOAD_OTHER_DOCUMENTS]: true,
      [DELETE_OTHER_DOCUMENTS]: true,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false
    },
    [EXPERT]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: false
    },
    [ADMIN]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: true,
      [EDIT_INSURED]: true,
      [EXPERT_CALL]: true,
      [OPEN_REPAIR]: false
    }
  },
  40: {
    [GARAGE]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: true,
      [DELETE_REGISTRATION]: true,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: true,
      [DELETE_ASSIGNMENT_REQUEST]: true,
      [UPLOAD_OTHER_DOCUMENTS]: true,
      [DELETE_OTHER_DOCUMENTS]: true,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false
    },
    [EXPERT]: {
      [UPLOAD_FILES]: true,
      [DELETE_FILES]: true,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: true,
      [EDIT_INSURED]: true,
      [EXPERT_CALL]: true,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: false
    },
    [ADMIN]: {
      [UPLOAD_FILES]: true,
      [DELETE_FILES]: true,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: true,
      [EDIT_INSURED]: true,
      [EXPERT_CALL]: true,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: false
    }
  },
  50: {
    [GARAGE]: {
      [UPLOAD_FILES]: true,
      [DELETE_FILES]: true,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: true,
      [DELETE_REGISTRATION]: true,
      [UPLOAD_FINANCIAL_OFFER]: true,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: true,
      [DELETE_ASSIGNMENT_REQUEST]: true,
      [UPLOAD_OTHER_DOCUMENTS]: true,
      [DELETE_OTHER_DOCUMENTS]: true,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: true,
      [EDIT_INSURED]: true,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false
    },
    [EXPERT]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: false
    },
    [ADMIN]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: false
    }
  },
  60: {
    [GARAGE]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: false
    },
    [EXPERT]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: true
    },
    [ADMIN]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: true
    }
  },
  70: {
    [GARAGE]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: true,
      [DELETE_REGISTRATION]: true,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: true,
      [DELETE_ASSIGNMENT_REQUEST]: true,
      [UPLOAD_OTHER_DOCUMENTS]: true,
      [DELETE_OTHER_DOCUMENTS]: true,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: false
    },
    [EXPERT]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: true
    },
    [ADMIN]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: true
    }
  },
  80: {
    [GARAGE]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: false
    },
    [EXPERT]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: false
    },
    [ADMIN]: {
      [UPLOAD_FILES]: true,
      [DELETE_FILES]: true,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: true,
      [DELETE_OTHER_DOCUMENTS]: true,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: true,
      [EDIT_INSURED]: true,
      [EXPERT_CALL]: true,
      [OPEN_REPAIR]: false
    }
  },
  90: {
    [GARAGE]: {
      [UPLOAD_FILES]: true,
      [DELETE_FILES]: true,
      [UPLOAD_REPAIRED_FILES]: true,
      [DELETE_REPAIRED_FILES]: true,
      [UPLOAD_REGISTRATION]: true,
      [DELETE_REGISTRATION]: true,
      [UPLOAD_FINANCIAL_OFFER]: true,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: true,
      [DELETE_ASSIGNMENT_REQUEST]: true,
      [UPLOAD_OTHER_DOCUMENTS]: true,
      [DELETE_OTHER_DOCUMENTS]: true,
      [UPLOAD_INVOICE]: true,
      [DELETE_INVOICE]: true,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false
    },
    [EXPERT]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: false
    },
    [ADMIN]: {
      [UPLOAD_FILES]: true,
      [DELETE_FILES]: true,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: true,
      [EDIT_INSURED]: true,
      [EXPERT_CALL]: true,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: false
    }
  },
  95: {
    [GARAGE]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: false
    },
    [EXPERT]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: false
    },
    [ADMIN]: {
      [UPLOAD_FILES]: true,
      [DELETE_FILES]: true,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: true,
      [DELETE_OTHER_DOCUMENTS]: true,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: true,
      [EDIT_INSURED]: true,
      [EXPERT_CALL]: true,
      [OPEN_REPAIR]: false
    }
  },
  100: {
    [GARAGE]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: false
    },
    [EXPERT]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: false,
      [CANCEL_EXPERT_DECISION]: false
    },
    [ADMIN]: {
      [UPLOAD_FILES]: false,
      [DELETE_FILES]: false,
      [UPLOAD_REPAIRED_FILES]: false,
      [DELETE_REPAIRED_FILES]: false,
      [UPLOAD_REGISTRATION]: false,
      [DELETE_REGISTRATION]: false,
      [UPLOAD_FINANCIAL_OFFER]: false,
      [DELETE_FINANCIAL_OFFER]: false,
      [UPLOAD_ASSIGNMENT_REQUEST]: false,
      [DELETE_ASSIGNMENT_REQUEST]: false,
      [UPLOAD_OTHER_DOCUMENTS]: false,
      [DELETE_OTHER_DOCUMENTS]: false,
      [UPLOAD_INVOICE]: false,
      [DELETE_INVOICE]: false,
      [EDIT_VEHICLE]: false,
      [EDIT_INSURED]: false,
      [EXPERT_CALL]: false,
      [OPEN_REPAIR]: true,
      [CANCEL_EXPERT_DECISION]: false
    }
  }
}
